import React, { Fragment, useState, useEffect } from "react";
import { Table } from "reactstrap";
import _ from "lodash";
import MyPostulationHit from "./Hit";

const MyPostulationsHits = ({ hits }) => {
  const [myPostulations, setMyPostulations] = useState(_.map(hits, hit => hit._source));

  useEffect(() => {
    const newPostulations = _.map(hits.hits || hits, hit => hit._source || hit);
    setMyPostulations(newPostulations);
  }, [hits]);

  return (
    <Fragment>
      {myPostulations.length === 0 ? (
        <div className="alert alert-warning">No se encontraron postulaciones</div>
      ) : (
        <Table hover>
          <thead>
          <tr>
            <th style={{ borderTop: "inherit" }}>Título</th>
            <th style={{ borderTop: "inherit" }}>Fecha de Postulación</th>
            <th style={{ borderTop: "inherit" }}>Línea de Tiempo</th>
          </tr>
          </thead>
          <tbody>
          {_.map(myPostulations, postulation => (
            <MyPostulationHit key={postulation.id} postulation={postulation} />
          ))}
          </tbody>
        </Table>
      )}
    </Fragment>
  );
};

export default MyPostulationsHits;
